module.exports = __webpack_public_path__ + "static/bg-coming-37eb2f44550aded78e075b9f64412888.png";